import { useState } from "react";
import { Button, Modal, Form } from "react-bootstrap";
import { socketEmit } from "../../Socket";

const EditMsg = ({ msg, id, messageType, recipient, sender, setChatMessages, chatMessages }) => {
  const [show, setShow] = useState(false);
  const [inputValue, setInputValue] = useState(msg);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleSave = () => {
    console.log("dsfsf", 
      {touserid: sender,
      recipient,
      messageType,
      content: inputValue,
      id: id,}
    )
    socketEmit("send_message", {
      touserid: sender,
      recipient,
      messageType,
      content: inputValue,
      id: id,
    }).then((parsedResponse) => {
      localStorage.getItem("chatMessages")
      const storedMessages = JSON.parse(localStorage.getItem("chatMessages")) || chatMessages;
      if (parsedResponse?.data?.id) {
        const updatedMessages = storedMessages.map(item =>
          item.id === parsedResponse?.data?.id ? parsedResponse?.data : item
        );
        localStorage.setItem("chatMessages", JSON.stringify(updatedMessages));
        setChatMessages(updatedMessages);
      }
      handleClose();
    });
  };

  return (
    <>
      <i className="bi bi-pen float-right" onClick={handleShow}></i>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update My Message</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form>
            <Form.Group controlId="formName">
              <Form.Control
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="success" onClick={handleSave}>
            Update
          </Button>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditMsg;
